import { Component, OnInit, Input, Output, EventEmitter, } from '@angular/core';
import { AlertService } from '../../services/alert.service';

@Component({
  selector: 'app-vacant-bed-select',
  templateUrl: './vacant-bed-select.component.html'
})
export class VacantBedSelectComponent implements OnInit {

  @Input() count: number = 0;
  @Output() countChange = new EventEmitter<number>();

  constructor(private alertService: AlertService) { }

  ngOnInit() {
  }

  change() {
    this.countChange.emit(this.count);
    this.alertService.resetStickyMessage();
  }
}
